(function ($) {
    // Stop click focus from staying
    $('.interactive__map-drawer-toggle').click(function () {
        $(this).blur();
        $('.interactive__map-drawer').toggleClass('show');
    });
})(jQuery);